import React , {useState , useEffect} from 'react';
import { useQuery } from '@apollo/react-hooks';
import {Skeleton} from '@material-ui/lab';
import Pusher from 'pusher-js';


import Notification from './notification.component';
import {GET_NOTIFICATION} from './apis';

import text from '../../languages/english/translate.json';

export default function AllNotifications(){
    const [ flag, setFlag ] = useState(0);
    const { loading, error, data ,refetch} = useQuery(GET_NOTIFICATION);

    useEffect(()=>{
        refetch();
        // Pusher.logToConsole = true;
        const userAuth = JSON.parse(localStorage.getItem('jwt'));
        const pusher = new Pusher('websocket',{
                      wsHost       : 'spreago.black-squares.com' ,
                      wssPort      : '6001' ,
                      authEndpoint : 'https://spreago.black-squares.com/api/authEndpoint' ,
                      forceTLS     : false             ,
                      disableStats : true              ,
                      auth: {
                        headers: {
                          'authorization': `Bearer ${userAuth.BearerTokenResponse?.access_token}`
                        }
                      }
                  });
        var channel = pusher.subscribe(`private-App.Models.User.${userAuth.user?.id}`);
        channel.bind('NewNotification', ()=> {
            setFlag(1);
        });
    },[data , refetch])
    if(flag === 1){
        refetch();
    }
    if(error) return `Error! ${error.message}`;
 
    return(
        <main className="container">
            <section className="border mt-3">
                <header className="bg-light border-bottom p-3">
                   <p className="text-dark mb-0 bold"> {text.notifications.AllNotification}</p>
                </header>
                <article className="p-3">
                    {loading && 
                        <>
                            <Skeleton className="border-bottom mb-3"  variant="text"/>
                            <Skeleton className="border-bottom mb-3"  variant="text"/>
                            <Skeleton className="border-bottom mb-3"  variant="text"/>
                            <Skeleton className="border-bottom mb-3"  variant="text"/>
                            <Skeleton className="border-bottom mb-3"  variant="text"/>
                            <Skeleton className="border-bottom mb-3"  variant="text"/>
                        </>
                    }
                    {data?.me && 
                        data.me.notifications.data.map(notification => 
                            <Notification 
                                id={notification.id} 
                                kind={notification.kind} 
                                message={notification.message} 
                                createAt={notification.created_at}
                                jobId={notification.job?.id}
                                companyId={notification.job?.id}
                                applicationId={notification.application?.id}/>
                        )
                    }
                </article>
            </section>
        </main>
    )
}